export const dataGruposDeAcessoReducer = (state, action) => {
  const { responseData, responseAllMenusData, responseAllApelidos } =
    action.payload;
  state.items = responseData?.items
    ? responseData?.items.filter((row: { idGrupo: string }) => !!row.idGrupo)
    : [];
  state.allItemsMenu = responseAllMenusData.items;
  state.allItemsApelidos = responseAllApelidos.items;
  state.pagination = {
    page: action.meta.arg?.pagina,
    rowsPerPage: action.meta.arg?.itensPorPagina,
    totalPages: responseData.totalPaginas,
    totalItems: responseData.totalRegistros,
  };
  state.requestGetParams = action.meta.arg;
};

export const dataMenusDeGrupoReducer = (state, action) => {
  state.itemsMenusDeGrupo = {
    ...state.itemsMenusDeGrupo,
    [action.meta.arg.grupoAcesso]: action.payload.items,
  };

  state.paginationMenusDeGrupo = {
    ...state.paginationMenusDeGrupo,
    [action.meta.arg.grupoAcesso]: {
      pagination: {
        page: action.meta.arg?.pagina,
        rowsPerPage: action.meta.arg?.itensPorPagina,
        totalPages: action.payload.totalPaginas,
        totalItems: action.payload.totalRegistros,
      },
    },
  };

  state.requestGetParamsMenusDeGrupo = {
    ...state.requestGetParamsMenusDeGrupo,
    [action.meta.arg.grupoAcesso]: action.meta.arg,
  };
};
